import { z } from 'zod';
import { Currency } from '@/features/dashboard/paymentConfig/types/Currency.ts';

export const expenseSchema = z.object({
  tourId: z.string().min(1, 'Wyjazd jest wymagany'),
  costCategoryId: z.string().min(1, 'Kategoria kosztów jest wymagana'),
  amount: z
    .number({ error: 'Kwota jest wymagana' })
    .positive('Kwota musi być większa niż 0'),
  currency: z.enum(Currency, { error: 'Waluta jest wymagana' }),
  dueDate: z.date({ error: 'Termin płatności jest wymagany' }),
  description: z.string().default(''),
});

export type ExpenseFormData = z.infer<typeof expenseSchema>;
export type ExpenseInputData = z.input<typeof expenseSchema>;

export const expenseDefaultValues: ExpenseInputData = {
  tourId: '',
  costCategoryId: '',
  amount: undefined as unknown as number,
  currency: Currency.PLN,
  dueDate: undefined as unknown as Date,
  description: '',
};
